import styled from 'styled-components';
import { Main } from '../../styles';

const imageLarge = '500px';
const imageMedium = '400px';
const imageSmall = '300px';

export const MainContainer = styled(Main)`
  position: relative;
`;

export const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const QuestionStringContainer = styled.div`
  text-align: center;
  & h1 {
    font-size: 2em;
    @media screen and (max-width: 600px) {
      font-size: 1.5em;
    }
  }
`;

export const QuestionAdminContainer = styled(QuestionStringContainer)`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`;

export const MediaContainer = styled.div`
  width: ${imageLarge};
  height: ${imageMedium};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;  
  @media screen and (max-width: 600px) {
    width: ${imageSmall};
    height: ${imageSmall};

  }
  @media screen and (min-width: 601px) and (max-width: 900px) {
    width: ${imageMedium};
    height: ${imageSmall};

  }
`;

export const Image = styled.img`
  width: ${imageLarge};
  @media screen and (max-width: 600px) {
    width: ${imageSmall};
  }
  @media screen and (min-width: 601px) and (max-width: 900px) {
    width: ${imageMedium};
  }
`;

export const AnswerAdminContainer = styled.div`
  margin: 24px;
`;

export const AnswerOuterContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media screen and (max-width: 700px) {
    display: flex;
    flex-direction: column;
  }

`;
export const AnswerContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 400px;
  height: 100px;
  margin: 3px;
  align-items: center;
  justify-content: space-around;
  background-color: #f0f0f0;
  border-radius: 4px;
  @media screen and (max-width: 500px) {
    width: 350px;
  }
  @media screen and (min-width: 501px) and (max-width: 700px) {
    width: 450px;
  }
  @media screen and (min-width: 701px) and (max-width: 900px) {
    width: 300px;
  }
`;
export const AnswerInnerContainer = styled.div`
  width: 150px;
  height: 50px;

  text-align: left;
  & span {
    color: white;
    line-height: 50px;
    font-size: 1.5em;
    font-weight: bold;
  }
`;

export const SelectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const MyCountdown = styled.div`
  position: absolute;
  left: 20px;
  top: 60px;
  transform: translateY(-50%);
  width: 100px;
  height: 100px;
  border-radius: 50%;
  text-align: center;
  background-color: #7d2ae8;
  & p {
    color: white;
    font-weight: bold;
    font-size: 4em;
    margin: auto;
    line-height: 100px;
    @media screen and (max-width: 650px) {
      font-size: 2em;
      line-height: 50px;
    }
  }
  @media screen and (max-width: 650px) {
    width: 50px;
    height: 50px;
    left: 10px;
    top: 30px;
  }
`;

export const ControlButton = styled.div`
  margin-left: 10px;
`;
